import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import api from '../utils/api'

interface Notice {
  id: number
  title: string
  content: string
  created_at: string
}

const Home = () => {
  const { user } = useAuth()
  const [notices, setNotices] = useState<Notice[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadNotices()
  }, [])

  const loadNotices = async () => {
    try {
      const response = await api.get('/notices')
      setNotices(response.data)
    } catch (error) {
      console.error('공지사항 로드 오류:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="container">
      <div style={{ textAlign: 'center', padding: '40px 0' }}>
        <h1 style={{ fontSize: '32px', marginBottom: '20px' }}>
          삼육대학교 교역자 계절대학 수강신청 시스템
        </h1>
        <p style={{ fontSize: '18px', color: '#666', marginBottom: '40px' }}>
          교역자 계절대학 수강신청을 위한 통합 관리 시스템입니다.
        </p>
        
        {user ? (
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/courses" className="btn btn-primary" style={{ padding: '15px 30px', fontSize: '16px' }}>
              강의 목록 보기
            </Link>
            <Link to="/my-enrollments" className="btn btn-secondary" style={{ padding: '15px 30px', fontSize: '16px' }}>
              내 수강신청
            </Link>
            <Link to="/my-grades" className="btn btn-success" style={{ padding: '15px 30px', fontSize: '16px' }}>
              내 성적 조회
            </Link>
          </div>
        ) : (
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/login" className="btn btn-primary" style={{ padding: '15px 30px', fontSize: '16px' }}>
              로그인
            </Link>
            <Link to="/register" className="btn btn-secondary" style={{ padding: '15px 30px', fontSize: '16px' }}>
              회원가입
            </Link>
            <Link to="/courses" className="btn btn-success" style={{ padding: '15px 30px', fontSize: '16px' }}>
              강의 목록 보기
            </Link>
          </div>
        )}

        <div className="card" style={{ marginTop: '40px', textAlign: 'left' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h2 style={{ margin: 0 }}>📢 공지사항</h2>
            {user?.role === 'admin' && (
              <Link to="/admin/notices" className="btn btn-primary" style={{ padding: '8px 16px', fontSize: '14px' }}>
                관리
              </Link>
            )}
          </div>
          
          {loading ? (
            <p style={{ textAlign: 'center', color: '#666', padding: '20px' }}>
              로딩 중...
            </p>
          ) : notices.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#666', padding: '20px' }}>
              등록된 공지사항이 없습니다.
            </p>
          ) : (
            <div>
              {notices.map(notice => (
                <div 
                  key={notice.id} 
                  style={{ 
                    padding: '20px', 
                    borderBottom: '1px solid #e0e0e0',
                    marginBottom: '15px'
                  }}
                >
                  <h3 style={{ 
                    fontSize: '18px', 
                    marginBottom: '10px',
                    color: '#333'
                  }}>
                    {notice.title}
                  </h3>
                  <div style={{ 
                    whiteSpace: 'pre-wrap', 
                    lineHeight: '1.8',
                    color: '#555',
                    marginBottom: '10px'
                  }}>
                    {notice.content}
                  </div>
                  <div style={{ 
                    fontSize: '12px', 
                    color: '#999',
                    textAlign: 'right'
                  }}>
                    작성일: {new Date(notice.created_at).toLocaleDateString('ko-KR', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Home


